<template>
   <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
         <div class="container-fluid">
            <div class="row mb-2">
               <div class="col-sm-6">
                  <h1 class="m-0">{{ $t('users') }}</h1>
               </div><!-- /.col -->
               <div class="col-sm-6">
                  <ol class="breadcrumb float-sm-right">
                     <li class="breadcrumb-item active">{{ $t('dashboard') }}</li>
                     <li class="breadcrumb-item active">{{ $t('users') }}</li>
                  </ol>
               </div><!-- /.col -->
            </div><!-- /.row -->
         </div><!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <section class="content">
         <div class="container-fluid">
            <!-- /.row -->
            <div class="row">
               <div class="col-12">
                  <div class="card">
                     <div class="card-header">
                        <router-link
                           :to="{ name: 'usersCreate' }"
                           class="btn btn-success"
                        >
                           <i class="fas fa-plus-circle"></i> {{ $t('create_user') }}
                        </router-link>

                        <div class="card-tools">
                           <div class="input-group input-group-sm pt-2" style="width: 350px;">
                              <input
                                 type="text"
                                 name="table_search"
                                 class="form-control float-right"
                                 placeholder="Buscar"
                                 v-model="searchQuery"
                                 @input="handleDelayedSearch">

                              <div class="input-group-append">
                                 <button type="submit" class="btn btn-default">
                                    <i class="fas fa-search"></i>
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                     <!-- /.card-header -->

                     <div v-if="isLoading" class="d-flex justify-content-center">{{ $t('loading') }}</div>

                     <div v-else class="card-body table-responsive p-0">
                        <table class="table table-hover text-nowrap">
                           <thead>
                           <tr>
                              <th>Nome</th>
                              <th>Email</th>
                              <th>Data de criação</th>
                              <th>Perfil</th>
                              <th>Status</th>
                              <th>Ação</th>
                           </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(user ,index) in users[currentPage - 1]" :key="index">
                                 <td>{{ user.name }}</td>
                                 <td>{{ user.email }}</td>
                                 <td>{{ user.createdAt }}</td>
                                 <td>{{ $t(`${user.profile}`) }}</td>
                                 <td>{{ user.isActive === true ? $t(`active`) : $t(`disabled`)  }}</td>
                                 <td>
                                    <div class="row">
                                       <router-link
                                          :to="{ name: 'usersEdit', params: { email: user.email } }"
                                          class="btn btn-sm btn-outline-primary text-bold"
                                       >
                                          <i class="pt-1 fas fa-pencil-alt"></i>
                                          {{ $t('edit') }}
                                       </router-link>
                                       <!--<button
                                          @click.prevent="disableUser(user.email)"
                                          class="ml-3 btn btn-sm btn-outline-secondary text-bold">
                                          <i class="pt-1 fas fa-user-edit"
                                       ></i>
                                          {{ $t('disable') }}
                                       </button>-->
                                    </div>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                     <!-- /.card-body -->

                     <div class="card-footer clearfix">
                        <pagination
                           v-if="!isSearching"
                           :totalPages="totalPages"
                           :currentPage="currentPage"
                           :isFirstPage="isFirstPage"
                           :isLastPage="isLastPage"
                           :adjacentPages="adjacentPages"
                           :tokenPages="tokenPages"
                           :isLoading="isLoadingPagination"
                           @page-selected="handlePageSelected"
                        />
                     </div>
                     <!-- /.card-footer -->

                  </div>
                  <!-- /.card -->
               </div>
            </div>
            <!-- /.row -->
         </div>
      </section>
      <!-- /.content -->
   </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import userService from "../services/user-service";
import { useToast } from "vue-toastification";
import Pagination from "../../../components/Pagination.vue";
import articleService from "../../article/services/article-service";

export default {
   name: "Users",
   components: {Pagination},
   setup() {
      const toast = useToast()
      return { toast }
   },
   data(){
      return {
         isLoading: false,
         searchTimeout: null,
         searchQuery: "",
         isSearching: false,
         adjacentPagesCount: 2,
         isLoadingPagination: false,
      }
   },
   computed: {
      ...mapState({
         currentPage: state => state.user.users.pagination.currentPage,
         users: state => state.user.users.data,
         tokenPages: state => state.user.users.pagination.tokenPages,
         totalPages: state => state.user.users.pagination.totalPages
      }),
      adjacentPages() {
         const currentIndex = this.tokenPages.findIndex((page) => page.page === this.currentPage);

         const startIdx = Math.max(0, currentIndex - this.adjacentPagesCount);
         const endIdx = Math.min(this.tokenPages.length - 1, currentIndex + this.adjacentPagesCount);

         const pages = this.tokenPages.slice(startIdx, endIdx + 1);

         return pages;
      },
      isFirstPage() {
         return this.currentPage === 1;
      },
      isLastPage() {
         return this.currentPage === this.totalPages;
      }
   },
   async created() {
      this.isLoading = true;
      this.isLoadingPagination = true;

      try {
         await this.getAllPaginatedUsers({ type: 'webUser' })

      } finally {
         this.isLoading = false;
         this.isLoadingPagination = false;
      }
   },
   methods: {
      ...mapActions(['getAllPaginatedUsers', 'searchUsers']),
      ...mapMutations({
         setCurrentPage: 'SET_USER_CURRENT_PAGE'
      }),
      async disableUser(email) {
         await userService.disable(email);

         const { data: response }  = await userService.getAll();
         this.users = response.data;

         this.toast.success(this.$t("disabled_with_success"));
      },
      async handleDelayedSearch() {
         clearTimeout(this.searchTimeout);
         this.isLoading = true;

         this.searchTimeout = setTimeout(async () => {
            if (this.searchQuery.length > 0) {
               this.setCurrentPage(1);
               this.isSearching = true;
               await this.searchUsers({type: 'webUser', name: this.searchQuery});
               this.isLoading = false;
            } else {
               this.isSearching = false;
               await this.getAllPaginatedUsers({ type: 'webUser' })
               this.isLoading = false;
            }
         }, 1000);
      },
      async handlePageSelected (action) {
         this.isLoading = true;
         let pageIndex;

         if (action === 'first' && !this.isFirstPage) {
            pageIndex = 1;
         } else if (action === 'prev' && !this.isFirstPage) {
            this.setCurrentPage(this.currentPage - 1);
            pageIndex = this.currentPage;
         } else if (action === 'next' && !this.isLastPage) {
            this.setCurrentPage(this.currentPage + 1);
            pageIndex = this.currentPage;
         } else if (action === 'last' && !this.isLastPage) {
            pageIndex = this.totalPages;
         } else if (typeof action === 'number') {
            pageIndex = action;
         }

         if (pageIndex) {
            const targetPage = this.tokenPages.find((page) => page.page === pageIndex);

            if (targetPage) {
               this.setCurrentPage(targetPage.page);
               this.isLoading = false;
            }
         }
      }
   }
}
</script>

<style scoped>

</style>
